import gql, { disableFragmentWarnings } from 'graphql-tag';

import VendorConfigFragment from './vendor-config';

disableFragmentWarnings();

export default gql`
  fragment VendorConfigsFragment on VendorConfigs {
    productNumber {
      ...VendorConfigFragment
    }
    productNumberDelivery {
      ...VendorConfigFragment
    }
  }

  ${VendorConfigFragment}
`;
